/* This file was generated automatically. Do not edit manually. */

export enum FixedInterval {
    CurrentMoment = 'CurrentMoment',
    CurrentDay = 'CurrentDay',
    CurrentWeek = 'CurrentWeek',
    CurrentMonth = 'CurrentMonth',
    CurrentQuarter = 'CurrentQuarter',
    CurrentYear = 'CurrentYear',
    NextDay = 'NextDay',
    NextWeek = 'NextWeek',
    NextMonth = 'NextMonth',
    NextQuarter = 'NextQuarter',
    NextYear = 'NextYear',
    PreviousDay = 'PreviousDay',
    PreviousWeek = 'PreviousWeek',
    PreviousMonth = 'PreviousMonth',
    PreviousQuarter = 'PreviousQuarter',
    PreviousYear = 'PreviousYear',
    MonthToDate = 'MonthToDate',
    YearToDate = 'YearToDate',
    NextTwoMonths = 'NextTwoMonths',
    NextThreeMonths = 'NextThreeMonths',
    LastDay = 'LastDay',
    LastWeek = 'LastWeek',
    LastMonth = 'LastMonth',
    DayAfterTomorrow = 'DayAfterTomorrow',
    DayBeforeYesterday = 'DayBeforeYesterday',
    UpcomingYear = 'UpcomingYear',
    UpcomingQuarter = 'UpcomingQuarter',
    RestOfCurrentMonth = 'RestOfCurrentMonth',
    LastHour = 'LastHour',
    MonthToYesterday = 'MonthToYesterday',
    RestOfCurrentYear = 'RestOfCurrentYear',
    OngoingSixMonths = 'OngoingSixMonths',
    OngoingYear = 'OngoingYear',
    OngoingTwoYears = 'OngoingTwoYears',
    OngoingThreeYears = 'OngoingThreeYears',
    OngoingFourYears = 'OngoingFourYears',
    OngoingFiveYears = 'OngoingFiveYears',
    PreviousDay0330ToCurrentDay0330 = 'PreviousDay0330ToCurrentDay0330',
    UntilCurrentMonth = 'UntilCurrentMonth',
}
